// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';

// Layouts
import LayoutConsole from '@layouts/LayoutConsole';

// Pages
import PageSettings from '@pages/settings';
import PageSettingsApiKeys from '@pages/settings/PageSettingsApiKeys';
import PageSettingsBlocks from '@pages/settings/PageSettingsBlocks';
import PageSettingsDomain from '@pages/settings/PageSettingsDomain';
import PageSettingsOptions from '@pages/settings-options';
import PageSettingsSenders from '@pages/settings/PageSettingsSenders';
import PageSettingsUnsubGroups from '@pages/settings-unsub-groups';
import PageSettingsUnsubGroupsMembers from '@pages/settings-unsub-groups/PageSettingsUnsubGroupsMembers';

export default {
    path: '/settings',
    component: LayoutConsole,
    meta: {
        middleware: [
            AuthMiddleware,
        ],
    },
    children: [
        {
            path: '',
            name: 'settings',
            component: PageSettings,
            redirect: {
                name: 'settings-api-keys'
            },
            children: [
                {
                    path: 'api-keys',
                    name: 'settings-api-keys',
                    component: PageSettingsApiKeys,
                    meta: {
                        title: 'Settings | API Keys',
                    },
                },
                {
                    path: 'options',
                    name: 'settings-options',
                    component: PageSettingsOptions,
                    meta: {
                        title: 'Settings | Options',
                    },
                },
                {
                    path: 'domain/:slug?',
                    name: 'settings-domain',
                    component: PageSettingsDomain,
                    meta: {
                        title: 'Settings | Sending Domain',
                    },
                },
                {
                    path: 'senders',
                    name: 'settings-senders',
                    component: PageSettingsSenders,
                    meta: {
                        title: 'Settings | Senders',
                    },
                },
                {
                    path: 'unsub-groups',
                    name: 'settings-unsub-groups',
                    component: PageSettingsUnsubGroups,
                    meta: {
                        title: 'Settings | Unsubscribe Groups',
                    },
                },
                {
                    path: 'unsub-groups/:id/members',
                    name: 'settings-unsub-groups-members',
                    component: PageSettingsUnsubGroupsMembers,
                    meta: {
                        title: 'Settings | Unsubscribe Groups | Members',
                    },
                },
                {
                    path: 'blocks',
                    name: 'settings-blocks',
                    component: PageSettingsBlocks,
                    meta: {
                        title: 'Settings | Blocks',
                    },
                },
            ],
        },
    ]
}